module.exports = __webpack_public_path__ + "img/azure-cloud-fundamentals.76c0becf.png";